import AlternateSizeGatsbyImage from '@root/joinroot.com/src/components/alternate-size-gatsby-image';
import BrandBling, { BRAND_BLING_OPTIONS } from '@root/joinroot.com/src/components/brand-bling';
import LinkButton from '@root/joinroot.com/src/components/buttons/link-button';
import LinkButtonModel from '@root/joinroot.com/src/models/link-button';
import Responsive from '@root/core/src/utils/responsive';
import environment from '@root/core/src/utils/environment';
import useAnalytics from '@root/core/src/hooks/use-analytics';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';
import { bold, semiBold } from '@root/brand/src/assets/fonts/root-sans/emotion';
import { graphql, useStaticQuery } from 'gatsby';

export default function StaticAspectRatioHero() {
  const { trackClick } = useAnalytics('BRAND_BUILDING_CAMPAIGN_HEADER', true);

  const { desktopImg, mobileImg } = useStaticQuery(graphql`
    query {
      desktopImg: file(relativePath: {eq: "brand-building/brand-building-hero_desktop.jpg"}) {
        childImageSharp {
          fluid(maxWidth: 1920, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mobileImg: file(relativePath: {eq: "brand-building/brand-building-hero_mobile.jpg"}) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);

  return (
    <section css={styles.section}>
      <div css={styles.wrapImage}>
        <AlternateSizeGatsbyImage
          desktop={desktopImg.childImageSharp.fluid}
          imageAltText={''}
          loading={'eager'}
          mobile={mobileImg.childImageSharp.fluid}
          styles={{
            height: '100%',
          }}
        />
      </div>
      <div css={styles.wrapContent}>
        <div css={styles.containerContent}>
          <h1 css={styles.headline}>
            <span>Your driving.</span>
            <br />
            <span>That’s what matters.</span>
          </h1>
          <h2 css={styles.subhead}>Good drivers could save hundreds.</h2>
          <LinkButton
            buttonStyles={styles.button}
            onClick={() => trackClick('GET_A_QUOTE_BUTTON')}
            to={environment.quoteAppBaseUrl}
            type={LinkButtonModel.types.PRIMARY}
          >
            Get a quote
          </LinkButton>
        </div>
      </div>
      <BrandBling
        brandBlingOptions={BRAND_BLING_OPTIONS.ICON}
      />
    </section>
  );
}

const styles = StyleSheet.create({
  section: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 30,
  },

  wrapImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: -1,
    overflow: 'hidden',
  },

  wrapContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '133vw',

    ...Responsive.md({
      height: '50vw',
    }),
    ...Responsive.xl({
      height: '43vw',
    }),
  },

  containerContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: 1200,
    padding: '40px 20px 20px',
    textAlign: 'center',

    ...Responsive.sm({
      padding: 20,
    }),
    ...Responsive.md({
      alignItems: 'flex-start',
      textAlign: 'left',
    }),
  },

  headline: {
    ...bold(),
    color: Colors.white(),
    fontSize: '8vw',
    letterSpacing: '-0.02em',

    ...Responsive.md({
      fontSize: 50,
    }),
    ...Responsive.xl({
      fontSize: 70,
    }),

    'span': {
      padding: '0 2vw',
      backgroundColor: Colors.rootOrange(),
      boxDecorationBreak: 'clone',
      lineHeight: '120%',

      ...Responsive.md({
        padding: '0 10px',
      }),
      ...Responsive.xl({
        padding: '0 14px',
      }),
    },
  },

  subhead: {
    margin: '10px 14px 30px',
    ...semiBold(),
    color: Colors.white(),
    fontSize: '6vw',
    letterSpacing: '-0.02em',
    lineHeight: '110%',
    textShadow: '0 0 20px rgba(0,0,0,0.9)',

    ...Responsive.sm({
      margin: '20px 14px 50px',
      maxWidth: '100%',
      fontSize: 32,
    }),
    ...Responsive.md({
      textShadow: 'none',
    }),
    ...Responsive.xl({
      fontSize: 42,
    }),
  },

  button: {
    margin: '0 14px',
  },
});

